import { render, staticRenderFns } from "./LcaProductDetail.vue?vue&type=template&id=fe039e9a&scoped=true"
import script from "./LcaProductDetail.vue?vue&type=script&lang=js"
export * from "./LcaProductDetail.vue?vue&type=script&lang=js"
import style0 from "./LcaProductDetail.vue?vue&type=style&index=0&id=fe039e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe039e9a",
  null
  
)

export default component.exports